import $ from 'jquery';
import React, { useState } from 'react';
import Numeral from 'numeral';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import CartImage from '../common/CartImage';
import ReactLoading from 'react-loading';
import {
    getCartItemTotalPrice,
    getFinalBuyableLink,
} from '../../selectors/cartSelector';
import { currencyDisplay } from '../../_utils';

function CartModalItem(props) {
    const [isToBeRemoved, setIsToBeRemoved] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const {
        item,
        removeItem,
        itemQty,
        currencyFormat,
        currencyDisplayCode,
        locale,
    } = props;
    const {
        ID,
        Title,
        InternalItemID,
        UnitPrice,
        TotalUnitItems,
        TotalPrice,
        TotalPriceWithoutTax,
        IsCustomTag,
        ParentItemID,
        Children = [],
        CanDelete = true,
    } = item;

    const cartItemKey = `cart-item-${ID}`;

    const handleConfirmRemove = (e) => {
        if (CanDelete === true) {
            setIsDeleting(true);
            removeItem(item, {
                success: () => {
                    $(`#${cartItemKey}`).slideUp();

                    if (Children.length > 0) {
                        Children.forEach((subitem) => {
                            const cartSubItemKey = `cart-item-${subitem.ID}`;
                            $(`#${cartSubItemKey}`).slideUp();
                        });
                    }
                },
                always: () => {
                    setIsDeleting(false);
                },
            });
        }
    };

    return (
        <li
            className={classnames(
                'cart-list__item form',
                isToBeRemoved === true && 'cart-list__item--removing',
                ParentItemID > 0 && 'cart-list__item--sub'
            )}
            id={cartItemKey}
        >
            <input type='hidden' name='ID' value={ID} />
            <div className='cart-list__indent'>
                <span className='icon-indent-arrow'></span>
            </div>
            <div className='cart-list__item-area'>
                <div className='cart-list__image'>
                    <CartImage item={item} />
                </div>
                <div className='cart-list__content-box'>
                    <div className='cart-list__extra-details'>
                        <span className='cart-list__sku'>{InternalItemID}</span>
                        {IsCustomTag === true && (
                            <a
                                href={getFinalBuyableLink(item)}
                                className='cart-list__label'
                            >
                                <span>
                                    <LocalizedMessage id={'CUSTOM_TAG'} />
                                </span>
                                <i className='icon icon-edit'></i>
                            </a>
                        )}
                    </div>
                    {ParentItemID > 0 ? (
                        <span className='cart-list__title' title={Title}>
                            {Title}
                        </span>
                    ) : (
                        <a
                            href={getFinalBuyableLink(item)}
                            className='cart-list__title'
                            title={Title}
                        >
                            {Title}
                        </a>
                    )}
                    <div className='cart-content'>
                        <div className='cart-content__col'>
                            <span className='cart-list__heading'>
                                <LocalizedMessage id={'UNIT_PRICE'} />
                            </span>
                            <span className='cart-list__value'>
                                {currencyDisplay(
                                    UnitPrice,
                                    currencyDisplayCode,
                                    currencyFormat,
                                    locale
                                )}
                            </span>
                        </div>
                        <div className='cart-content__col'>
                            <span className='cart-list__heading'>
                                <LocalizedMessage id={'QUANTITY'} />
                            </span>
                            <span className='cart-list__value'>
                                {Numeral(itemQty).format('0,0')}
                            </span>
                        </div>
                        <div className='cart-content__col'>
                            <span className='cart-list__heading'>
                                <LocalizedMessage id={'TOTAL'} />
                            </span>
                            <span className='cart-list__value'>
                                {currencyDisplay(
                                    getCartItemTotalPrice(
                                        TotalPrice,
                                        TotalPriceWithoutTax
                                    ),
                                    currencyDisplayCode,
                                    currencyFormat,
                                    locale
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                {window.currentOrderPaymentMethod ==
                    'order-card-authorization-payfast' && window.isEditOrder ? (
                    <></>
                ) : (
                    <button
                        type='button'
                        className='cart-list__remove'
                        title='Remove'
                        onClick={() =>
                            CanDelete === true && setIsToBeRemoved(true)
                        }
                        style={{ opacity: CanDelete === true ? 1 : 0 }}
                    >
                        <i className='icon icon-bin-thick' />
                    </button>
                )}
            </div>
            {CanDelete === true && (
                <div className='cart-list__undo'>
                    <div className='cart-list__undo__text'>
                        <LocalizedMessage id={'REMOVE_ITEM_FROM_CART'} />
                    </div>
                    <button
                        type='button'
                        className='cart-list__undo__button'
                        onClick={() => setIsToBeRemoved(false)}
                    >
                        <LocalizedMessage id={'CANCEL'} />
                    </button>
                    <button
                        type='button'
                        className='cart-list__undo__button cart-list__undo__button--green cart-list__undo__button--uppercase'
                        onClick={handleConfirmRemove}
                    >
                        {isDeleting == true && (
                            <ReactLoading
                                type='spin'
                                className='button__spinner'
                                color='black'
                                height={20}
                                width={20}
                            />
                        )}
                        <span style={{ opacity: isDeleting ? 0 : 1 }}>
                            <LocalizedMessage id={'CONFIRM'} />
                        </span>
                    </button>
                </div>
            )}
        </li>
    );
}

export default CartModalItem;
